import { ChartTypeValue } from 'src/common/components/ChartTypeToggle/ChartTypeToggle';
import { PeriodTypeValue } from 'src/common/components/PeriodTypeSwitch/PeriodTypeSwitch';
import { UsageTypeValue } from 'src/common/components/UsageTypeSwitch/UsageTypeSwitch';

type UsageFilters = {
  accountRef: string;
  usageType?: UsageTypeValue;
  chartType?: ChartTypeValue;
};

export const rsimGraphsQueries = {
  all: ['RsimGraphs'],
  perforance: (filters: { accountRef: string; periodType: PeriodTypeValue }) => [
    ...rsimGraphsQueries.all,
    'Performance',
    filters,
  ],
  usage: (filters: UsageFilters) => [...rsimGraphsQueries.all, 'Usage', filters],
};
